import { render } from "./CandidateRecords.vue?vue&type=template&id=2318964a"
import script from "./CandidateRecords.vue?vue&type=script&lang=js"
export * from "./CandidateRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__